import { render, staticRenderFns } from "./user-wallet-details.vue?vue&type=template&id=150bb0f0&scoped=true"
import script from "./user-wallet-details.vue?vue&type=script&lang=js"
export * from "./user-wallet-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150bb0f0",
  null
  
)

export default component.exports